import { render, staticRenderFns } from "./IconDeliveryVan.vue?vue&type=template&id=5d205cbc&scoped=true&"
var script = {}
import style0 from "./IconDeliveryVan.vue?vue&type=style&index=0&id=5d205cbc&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d205cbc",
  null
  
)

export default component.exports